module.exports = __webpack_public_path__ + "img/32exp.50f568ba.jpg";